'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cp = require('./cp.js');

var rm = require('./rm.js');

var mergeOpts = require('merge-options');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var defaultOptions = {
  parents: false,
  flush: true,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  shardSplitThreshold: 1000
};

function createMv(context) {
  function mfsMv(_x, _x2) {
    return _mfsMv.apply(this, arguments);
  }

  function _mfsMv() {
    _mfsMv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(from, to) {
      var options,
          opts,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              opts = mergeOptions(defaultOptions, options);
              _context.next = 4;
              return cp.createCp(context)(from, to, opts);

            case 4:
              _context.next = 6;
              return rm.createRm(context)(from, _objectSpread(_objectSpread({}, opts), {}, {
                recursive: true
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _mfsMv.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsMv);
}

exports.createMv = createMv;